import { render, staticRenderFns } from "./InventoryDialog.vue?vue&type=template&id=8037ba16&"
import script from "./InventoryDialog.vue?vue&type=script&lang=js&"
export * from "./InventoryDialog.vue?vue&type=script&lang=js&"
import style0 from "./InventoryDialog.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports